import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IRestaurantDetail } from "../models/IRestaurantDetail";
import { getOrderHistory } from "../services/orderHistory";
import { getRestaurantById } from "../services/restaurants";
import { S3_IMAGE_BASE_URL } from "../services/config";
import { isLoggedIn } from "../utils/tokenUtils";
import { useLanguage } from "../context/LanguageContext";
import "../styles/style.css";

const toApiDate = (d: Date) => {
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${m}.${day}.${d.getFullYear()}`;
};

function ReorderSection() {
  const [restaurants, setRestaurants] = useState<IRestaurantDetail[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { t } = useLanguage();

  useEffect(() => {
    if (!isLoggedIn()) {
      setLoading(false);
      return;
    }

    const now = new Date();
    const past = new Date(now.getTime() - 90 * 24 * 60 * 60 * 1000);

    getOrderHistory(toApiDate(past), toApiDate(now))
      .then((res) => {
        const orders = res.data.slice(0, 4);
        const uniqueIds = Array.from(
          new Set(orders.map((o) => o.preOrder?.restourantId).filter((id): id is string => !!id))
        );
        return Promise.all(
          uniqueIds.map((id) =>
            getRestaurantById(id)
              .then((r) => r.data)
              .catch(() => null)
          )
        );
      })
      .then((results) => {
        setRestaurants(results.filter((r): r is IRestaurantDetail => r !== null));
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (!isLoggedIn() || loading || restaurants.length === 0) return null;

  return (
    <div className="reorder-section">
      <div className="reorder-section__title">
        <i className="bi bi-arrow-repeat me-1"></i>
        {t("dashboard.reorderTitle")}
      </div>
      <div className="reorder-section__scroll">
        {restaurants.map((r) => (
          <div
            key={r.id}
            className="reorder-section__card"
            onClick={() => navigate(`/restaurants/${r.id}`)}
          >
            <div className="reorder-section__img">
              {r.restourantLogoPath ? (
                <img
                  src={S3_IMAGE_BASE_URL + r.restourantLogoPath}
                  alt={r.restourantName}
                />
              ) : (
                <i className="bi bi-shop text-muted" style={{ fontSize: "2rem" }}></i>
              )}
            </div>
            <div className="reorder-section__info">
              <div className="reorder-section__name">{r.restourantName}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ReorderSection;
